import { useCallback, useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import {
  rescheduleOpenDockWarehouseAppointment,
  type RescheduleOpenDockWarehouseAppointmentUseCaseParams,
} from '../../use-cases/rescheduleOpenDockWarehouseAppointment'

type RescheduleParams = RescheduleOpenDockWarehouseAppointmentUseCaseParams

export function useRescheduleOpenDockWarehouseAppointment() {
  const [requestStatus, setRequestStatus] = useState(RequestStatus.Initial)

  const reschedule = useCallback(async (params: RescheduleParams) => {
    setRequestStatus(RequestStatus.Pending)
    try {
      await rescheduleOpenDockWarehouseAppointment(params)
    } catch (error) {
      setRequestStatus(RequestStatus.Initial)
      throw error
    }
    setRequestStatus(RequestStatus.Initial)
  }, [])

  return { reschedule, requestStatus }
}
